export default __webpack_public_path__ + "static/media/kek-co-logo.0d38a5be.png";